// Gradient hairline with a centered diamond glyph. A quieter alternative to
// a flat rule line. Used between sections (Library list, Settings panels,
// Matches sections) and as a chapter break inside cards.

interface InkDividerProps {
  /** Glyph in the center. ◆ (filled) or ◇ (outline). Defaults to ◇. */
  glyph?: '◆' | '◇' | '·';
  /** Hairline + glyph color. Defaults to soft gold. */
  color?: string;
  /** Extra classes (typically margin). */
  className?: string;
}

export function InkDivider({
  glyph = '◇',
  color = '#C9A36A',
  className = '',
}: InkDividerProps) {
  return (
    <div
      aria-hidden
      className={`flex items-center gap-3 ${className}`}
    >
      <span
        className="flex-1 h-px"
        style={{
          background: `linear-gradient(to right, transparent, ${color}55 40%, ${color}55 60%, transparent)`,
        }}
      />
      <span
        className="text-[10px] leading-none"
        style={{ color, opacity: 0.7 }}
      >
        {glyph}
      </span>
      <span
        className="flex-1 h-px"
        style={{
          background: `linear-gradient(to right, transparent, ${color}55 40%, ${color}55 60%, transparent)`,
        }}
      />
    </div>
  );
}
